import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import './error.css'
class Error403 extends Component {

render() {

    
    return (
        <div className='errorpages'>
            <div>
                403
            </div>
        <div className='errorsub'>
            <div>
                ACCESS DENIED
            </div>
            <div>
            The page of resource you were trying to reach is forbidden for some reason.
            </div>
            <div>
                <Link to='/'>
                <button>GO HOME</button>
                </Link>
            </div>
            </div>
        </div>
    )
}
}


export default Error403;
